import React from 'react';
import { bgImage } from './../scripts';
import { heights, widths } from './../styles/theme.json';

const BwSignature = (props) => {
  return (
    <div className={(props.position == 'top') ? 'signature-wrapper' : 'signature-loader'}>
      <div className={'inner-signature'}>
        {
          (props.color == 'white')
          ? <div className={'signature'} style={bgImage('/static/icons/bw-cursive.svg')}/>
          : <div className={'signature'} style={bgImage('/static/icons/bw-cursive-blk.svg')}/>
        }
      </div>
      <style jsx>{`
        @keyframes pulse {
          0% {
            opacity: 0;
          }
          15% {
            opacity: .25;
          }
          50% {
            opacity: 1;
          }
          90% {
            opacity: .25;
          }
          100% {
            opacity: 0;
          }
        }
        .signature-wrapper {
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          padding-left: ${widths.single_pad};
          padding-right: ${widths.single_pad};
          padding-top: 4rem;
        }
        .signature-loader {
          animation: pulse 5000ms infinite linear;
          padding-bottom: 6rem;
        }
        .inner-signature {
          width: 100%;
          margin: auto;
        }
        .signature {
          background-repeat: no-repeat;
          background-position: center;
          background-size: contain;
          width: 12.6rem;
          height: 6.6rem;
        }
      `}</style>
    </div>
  );
};

export default BwSignature;



// WEBPACK FOOTER //
// ./src/components/BwSignature.js